import { createSlice } from "@reduxjs/toolkit";

const messages = createSlice({
    name: "messages",
    initialState: {
        partOfferMessages: [],
        partOfferMessagesLoaded: false,
        activeRequestsMessages: [],
        activeRequestsMessagesLoaded: false,
        otherMessages: [],
        otherMessagesLoaded: false,
    },
    reducers: {
        getPartOfferMessages(state, _action) {
            return { ...state, partOfferMessagesLoaded: false }
        },
        setPartOfferMessages(state, action) {
            const requestData = Object.values(action.payload);

            return {
                ...state,
                partOfferMessages: requestData[1],
                partOfferMessagesCount: requestData[0],
                partOfferMessagesLoaded: true,
            }
        },
        getActiveRequestsMessages(state, _action) {
            return { ...state, activeRequestsMessagesLoaded: false }
        },
        setActiveRequestsMessages(state, action) {
            const requestData = Object.values(action.payload);

            return {
                ...state,
                activeRequestsMessages: requestData[1],
                count: requestData[0],
                activeRequestsMessagesLoaded: true,
            }
        },
        getOtherMessages(state, _action) {
            return { ...state, otherMessagesLoaded: false }
        },
        setOtherMessages(state, action) {
            const requestData = Object.values(action.payload);

            return {
                ...state,
                otherMessages: requestData[1],
                otherMessagesCount: requestData[0],
                otherMessagesLoaded: true,
            }
        },
        sendMessage(state, _action) {
            return { ...state, partOfferMessagesLoaded: false }
        },
    },
});

export const {
    getPartOfferMessages,
    setPartOfferMessages,
    getActiveRequestsMessages,
    setActiveRequestsMessages,
    getOtherMessages,
    setOtherMessages,
    sendMessage
} = messages.actions;

export default messages.reducer;
